export const DEFAULT_SUPPORTER_PACKAGES = [
  {
    name: 'Platinum Supporter',
    price: 5000000,
    description: 'Maximum visibility and recognition',
    features: [
      'Premium booth location (6m x 6m)',
      'Logo on all conference materials',
      'Dedicated session sponsorship',
      '5 complimentary registrations',
      'Company profile in conference app',
      'Branding in main conference hall',
      'Welcome dinner table sponsorship',
      'Social media promotion',
    ],
    recommended: true,
  },
  {
    name: 'Gold Supporter',
    price: 3000000,
    description: 'High visibility and engagement',
    features: [
      'Premium booth location (6m x 3m)',
      'Logo on conference materials',
      '3 complimentary registrations',
      'Company profile in conference app',
      'Branding in break areas',
      'Social media promotion',
    ],
  },
  {
    name: 'Silver Supporter',
    price: 2000000,
    description: 'Great visibility opportunity',
    features: [
      'Standard booth location (3m x 3m)',
      'Logo on selected materials',
      '2 complimentary registrations',
      'Company listing in conference app',
      'Social media mention',
    ],
  },
  {
    name: 'Bronze Supporter',
    price: 1000000,
    description: 'Basic support package',
    features: [
      'Standard booth location (3m x 3m)',
      'Company listing in conference app',
      '1 complimentary registration',
      'Logo on website',
    ],
  },
];

export const DEFAULT_EXHIBITOR_PACKAGES = [
  {
    name: 'Premium Exhibitor',
    price: 1500000,
    description: 'Maximum exposure for exhibitors',
    features: [
      'Premium booth location (6m x 3m)',
      '2 complimentary registrations',
      'Company profile in conference materials',
      'Logo on website and app',
      'Early setup access',
      'Dedicated marketing support',
    ],
    recommended: true,
  },
  {
    name: 'Standard Exhibitor',
    price: 800000,
    description: 'Standard exhibition package',
    features: [
      'Standard booth location (3m x 3m)',
      '1 complimentary registration',
      'Company listing in materials',
      'Logo on website',
      'Standard setup access',
    ],
  },
  {
    name: 'Basic Exhibitor',
    price: 500000,
    description: 'Basic exhibition opportunity',
    features: [
      'Standard booth location (3m x 3m)',
      'Company listing in app',
      'Basic setup access',
    ],
  },
];

export const DEFAULT_ADVERTISING_PACKAGES = [
  {
    name: 'Journal - Full Page',
    price: 2000000,
    description: 'Full page advertisement in conference journal',
    features: [
      'Full page color advertisement',
      'Premium placement (inside front/back cover)',
      'High-quality print production',
      'Reach all conference attendees',
      'Digital version included',
      'Company logo and contact information',
    ],
    category: 'journal',
    recommended: true,
  },
  {
    name: 'Journal - Half Page',
    price: 1200000,
    description: 'Half page advertisement in conference journal',
    features: [
      'Half page color advertisement',
      'Strategic placement within journal',
      'High-quality print production',
      'Reach all conference attendees',
      'Digital version included',
      'Company logo and contact information',
    ],
    category: 'journal',
  },
  {
    name: 'Journal - Quarter Page',
    price: 700000,
    description: 'Quarter page advertisement in conference journal',
    features: [
      'Quarter page color advertisement',
      'Standard placement within journal',
      'High-quality print production',
      'Reach all conference attendees',
      'Digital version included',
      'Company logo and contact information',
    ],
    category: 'journal',
  },
  {
    name: 'Abstract Book - Full Page',
    price: 1800000,
    description: 'Full page advertisement in abstract book',
    features: [
      'Full page color advertisement',
      'Premium placement (inside front/back cover)',
      'High-quality print production',
      'Reach all conference attendees',
      'Digital version included',
      'Company logo and contact information',
    ],
    category: 'abstract-book',
    recommended: true,
  },
  {
    name: 'Abstract Book - Half Page',
    price: 1000000,
    description: 'Half page advertisement in abstract book',
    features: [
      'Half page color advertisement',
      'Strategic placement within abstract book',
      'High-quality print production',
      'Reach all conference attendees',
      'Digital version included',
      'Company logo and contact information',
    ],
    category: 'abstract-book',
  },
  {
    name: 'Abstract Book - Quarter Page',
    price: 600000,
    description: 'Quarter page advertisement in abstract book',
    features: [
      'Quarter page color advertisement',
      'Standard placement within abstract book',
      'High-quality print production',
      'Reach all conference attendees',
      'Digital version included',
      'Company logo and contact information',
    ],
    category: 'abstract-book',
  },
  {
    name: 'Name Tag - Full Back',
    price: 1500000,
    description: 'Full back advertisement on all name tags',
    features: [
      'Full back advertisement on all name tags',
      'High visibility throughout conference',
      'Professional print quality',
      'Reach every attendee',
      'Logo and contact information',
      'Brand exposure at all sessions',
    ],
    category: 'name-tag',
    recommended: true,
  },
  {
    name: 'Name Tag - Half Back',
    price: 900000,
    description: 'Half back advertisement on all name tags',
    features: [
      'Half back advertisement on all name tags',
      'High visibility throughout conference',
      'Professional print quality',
      'Reach every attendee',
      'Logo and contact information',
      'Brand exposure at all sessions',
    ],
    category: 'name-tag',
  },
  {
    name: 'Name Tag - Logo Only',
    price: 500000,
    description: 'Company logo on all name tags',
    features: [
      'Company logo on all name tags',
      'High visibility throughout conference',
      'Professional print quality',
      'Reach every attendee',
      'Brand recognition',
      'Cost-effective advertising option',
    ],
    category: 'name-tag',
  },
];

export const DEFAULT_PACKAGES_SETTINGS = {
  page_intro:
    'Join us as a supporter or exhibitor at the 41st Tanzania Dental Association Scientific Conference & AGM 2026. Choose from our range of packages designed to maximize your visibility and engagement. We also offer advertising opportunities in our journal, abstract book, and name tags.',
  supporter_section_description:
    'Support the conference and gain maximum visibility with our tiered supporter packages.',
  exhibitor_section_description:
    'Showcase your products and services to dental professionals from across Tanzania and East Africa.',
  advertising_section_description:
    'Promote your brand through our conference materials. Reach all attendees with advertising in our journal, abstract book, and name tags.',
  supporter_packages: DEFAULT_SUPPORTER_PACKAGES,
  exhibitor_packages: DEFAULT_EXHIBITOR_PACKAGES,
  advertising_packages: DEFAULT_ADVERTISING_PACKAGES,
};
